import { JsonSchemaModel } from '../Models/JsonSchemaModel';

/** Array nullability belongs to the collection, not its item type. */
export function readSchemaEditorCollection(schema: JsonSchemaModel) {
	const types = Array.isArray(schema.type) ? schema.type : [schema.type];
	const isMultiple = types.includes('array') && types.every((type) => type === 'array' || type === 'null');
	return {
		isMultiple,
		isNullableCollection: isMultiple && types.includes('null'),
		itemSchema: isMultiple && schema.items && !Array.isArray(schema.items) ? schema.items : schema,
	};
}

export function writeSchemaEditorCollection(itemSchema: JsonSchemaModel, nullable = false): JsonSchemaModel {
	return { type: nullable ? ['array', 'null'] : 'array', items: itemSchema };
}
